<script setup lang="ts">
defineExpose({
  name: 'TableSkeletonItem',
});

interface Props {
  type: 'information' | 'table';
}
const props = withDefaults(defineProps<Props>(), {
  type: 'information',
});
</script>

<template>
  <div class="TableSkeletonItem" :class="`TableSkeletonItem--${type}`">
    <div class="TableSkeletonItem__bar shimmer"></div>
    <div class="TableSkeletonItem__bar shimmer"></div>
  </div>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.TableSkeletonItem {
  display: flex;

  &--information {
    align-items: center;
    height: $service-unit * 10;
  }

  &--table {
    align-items: flex-end;
    height: $service-unit * 12;
    padding: 0 $service-unit * 4;
  }

  &__bar {
    height: $service-unit * 4;
    background-color: $color-gray-20;
  }

  &--information &__bar {
    &:first-child {
      width: 100% * calc(180 / 1104);
    }

    &:nth-child(2) {
      width: 100% * calc(450 / 1104);
      margin-left: $service-unit * 6;
    }
  }

  &--table &__bar {
    &:first-child {
      width: 100% * calc(160 / 1104);
    }

    &:nth-child(2) {
      width: calc(100% - $service-unit * 6);
      margin-left: $service-unit * 6;
    }
  }
}
</style>
